import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "25",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#1F2937",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m9.5 18 6-6-6-6",
      class: "dark:stroke-white"
    }, null, -1)
  ]))]))
}
export default { render: render }